import { Button } from "@stackje/shared-components/ui/button";
import { Input } from "@stackje/shared-components/ui/input";
import { Label } from "@stackje/shared-components/ui/label";

interface OtpVerificationProps {
  email: string;
  otpCode: string;
  setOtpCode: (code: string) => void;
  loading: boolean;
  onVerify: (e: React.FormEvent<HTMLFormElement>) => void;
  onResend?: () => void;
  resendLoading?: boolean;
  message?: string;
  description?: string;
}

export function OtpVerification({
  email,
  otpCode,
  setOtpCode,
  loading,
  onVerify,
  onResend,
  resendLoading,
  message,
  description = "Enter the 6-digit code from your email, or click the link in the email to verify automatically.",
}: OtpVerificationProps) {
  return (
    <form onSubmit={onVerify} className="space-y-4 text-left">
      <div>
        <Label htmlFor="otpCode">Verification Code</Label>
        <p className="text-sm text-gray-600 mb-2">
          We sent a verification code to <strong>{email}</strong>
        </p>
        <Input
          id="otpCode"
          type="text"
          value={otpCode}
          onChange={(e) => setOtpCode(e.target.value)}
          placeholder="Enter 6-digit code"
          required
          className="mt-1"
          maxLength={6}
          pattern="[0-9]{6}"
        />
        <p className="text-xs text-gray-500 mt-1">
          {description}
        </p>
        {message && (
          <p className="text-green-600 text-sm mt-2">{message}</p>
        )}
      </div>
      <div className="space-y-3">
        <Button type="submit" className="w-full" disabled={loading}>
          {loading ? "Verifying..." : "Verify Email"}
        </Button>
        {onResend && (
          <Button
            type="button"
            variant="outline"
            onClick={onResend}
            disabled={resendLoading}
            className="w-full"
          >
            {resendLoading ? "Sending..." : "Resend verification code"}
          </Button>
        )}
      </div>
    </form>
  );
}